import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule} from "@angular/forms";
import {LoaderModule} from "@shopping-angular-components/loader";
import { EntitiesAutocompleteComponent } from './entities-autocomplete.component';
import {TranslateModule} from "@ngx-translate/core";
import { TooltipModule } from '@shopping-angular-components/tooltip';



@NgModule({
  declarations: [
    EntitiesAutocompleteComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        TooltipModule,
        LoaderModule,
        TranslateModule
    ],
  exports: [
    EntitiesAutocompleteComponent
  ]
})
export class EntitiesAutocompleteModule { }
